/**
 * Composable card with optional header, body and footer slots.
 *
 * @example
 * <Card>
 *   <Card.Header title="Users" action={<Button>Add</Button>} />
 *   <Card.Body><p>Content</p></Card.Body>
 *   <Card.Footer><span>12 items</span></Card.Footer>
 * </Card>
 */
const Card = ({ children, className = '', ...props }) => (
  <div
    className={[
      'rounded-lg border border-edge bg-surface shadow-sm',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    {children}
  </div>
);

const CardHeader = ({ title, description, action, className = '' }) => (
  <div
    className={[
      'flex items-center justify-between border-b border-edge px-6 py-4',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <div>
      {title && (
        <h3 className="text-base font-semibold text-content">{title}</h3>
      )}
      {description && (
        <p className="mt-0.5 text-sm text-content-muted">{description}</p>
      )}
    </div>
    {action && <div className="ml-4 flex-shrink-0">{action}</div>}
  </div>
);

const CardBody = ({ children, className = '' }) => (
  <div className={['px-6 py-4', className].filter(Boolean).join(' ')}>{children}</div>
);

const CardFooter = ({ children, className = '' }) => (
  <div
    className={[
      'border-t border-edge px-6 py-3',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
